import {
  TrackingPageContext,
  originClick,
  trackOriginClick,
} from '@aboutyou/legacy-tracking-sdk';
import {useTracking} from './utils';

export const useOriginClick = () => {
  const {TrackingClient, pageContextCallback} = useTracking();

  return (type: any, mappedData: any) => {
    const pageContext = pageContextCallback();
    // for brand logo on adp
    const isRecoType =
      mappedData.section.recoType !== undefined &&
      (pageContext.type === 'adp' || pageContext.type === 'brand_discover');
    if (
      type === 'click' &&
      (isRecoType ||
        pageContext.type === 'category' ||
        pageContext.type === 'brand')
    ) {
      TrackingClient.track(
        trackOriginClick({
          origin: getOriginClick(mappedData, pageContext) as originClick,
        }),
      );
    }
  };
};

const getOriginClick = (mappedData: any, pageContext: TrackingPageContext) => {
  const isADP = pageContext.type === 'adp';
  const isCategoryPage = pageContext.type === 'category';
  const isBrandPage = pageContext.type === 'brand';
  const isBrandDiscoverPage = pageContext.type === 'brand_discover';
  const isOffcanvas = pageContext.type === 'offCanvas';

  if (isOffcanvas) {
    return 'last_seen_products_reco';
  }
  if (isADP) {
    return mappedData.section.recoType;
  } else if (isBrandDiscoverPage) {
    return mappedData.section.recoType;
  } else if (isCategoryPage || isBrandPage) {
    const mappedDataKeys = Object.keys(mappedData);
    const isPromotion = mappedDataKeys.includes('promotion');
    const isProduct = mappedDataKeys.includes('product');

    if (isPromotion) {
      const section = mappedData.promotion.creative.includes('top_banner')
        ? 'top_banner'
        : mappedData.promotion.creative;
      return getOriginClickCategoryPage(section);
    } else if (isProduct) {
      return mappedData.section.recoType ?? 'product_stream';
    }
  }
};

const getOriginClickCategoryPage = (section: string) => {
  switch (section) {
    case 'story_reco':
      return 'story_category_reco';
    case 'outfit_reco':
      return 'outfit_category_reco';
    case 'top_banner':
      return 'bas_category_header';
    case 'bas_category_teaser':
      return 'bas_category_teaser';
    default:
      return null;
  }
};
